import React from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import {
  getQuestionTypes,
  createQuestionType,
  updateQuestionType,
  deleteQuestionType,
} from "../../../services/QuestionTypeService";
import { useTranslation } from "react-i18next";

const QuestionTypes = () => {
  const { t } = useTranslation();
  return (
  <GenericCrudPage
      permissionModule="QUESTION_TYPE"
    title={t("pages.questionTypes.title")}
    breadcrumbLabel={t("pages.questionTypes.breadcrumb")}
    addLabel={t("pages.questionTypes.addLabel")}
    searchPlaceholder={t("common.ui.rechercherCodeNom")}
    defaultSort={{ by: "name", dir: "asc" }}
    api={{
      list: getQuestionTypes,
      create: createQuestionType,
      update: updateQuestionType,
      remove: deleteQuestionType,
    }}
    columns={[
      { key: "code", label: t("common.fields.code"), sortable: true },
      { key: "name", label: t("common.fields.name"), sortable: true },
      {
        key: "allows_multiple_correct",
        label: t("pages.questionTypes.allowsMultiple"),
        render: (row) => (row.allows_multiple_correct ? t("common.fields.yes") : t("common.fields.no")),
      },
      { key: "description", label: t("common.fields.description"), render: (row) => row.description || "-" },
    ]}
    fields={[
      { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "SINGLE_CHOICE", maxLength: 20 },
      { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.questionTypes.choixUnique"), maxLength: 100 },
      { key: "allows_multiple_correct", label: t("pages.questionTypes.allowsMultipleField"), type: "checkbox" },
      { key: "description", label: t("common.fields.description"), type: "textarea" },
      { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
    ]}
    buildPayload={(formData) => ({
      code: formData.code.trim(),
      name: formData.name.trim(),
      allows_multiple_correct: !!formData.allows_multiple_correct,
      description: formData.description?.trim() || null,
      is_active: formData.is_active !== undefined ? !!formData.is_active : true,
    })}
    getItemLabel={(item) => item.name}
  />
);
};

export default QuestionTypes;
